import { Action } from "@ngrx/store";

export enum EUIActions {
    SetUsername = '[UI] SET USERNAME',
}

export class SetUsername implements Action {
    public readonly type = EUIActions.SetUsername;
    constructor(public payload: string) { }
}

export type UIActions =
    SetUsername
    ;
